import Types from '../Types'

// User
const attemptFindOrders = (payload) => ({
  type: Types.FIND_ORDERS_ATTEMPT, payload
})

const attemptGetCart = () => ({
  type: Types.GET_CART_ATTEMPT
})

const attemptAddToCart = (payload) => ({
  type: Types.ADD_TO_CART_ATTEMPT, payload
})

const attemptSaveCart = (payload) => ({
  type: Types.SAVE_CART_ATTEMPT, payload
})

const attemptCheckout = (payload) => ({
  type: Types.CHECKOUT_ATTEMPT, payload, options: { cartOrderId: payload.cartOrderId }
})

const attemptReorder = (payload) => ({
  type: Types.REORDER_ATTEMPT, payload
})

// Admin
const attemptFindAllOrders = (payload) => ({
  type: Types.FIND_ALL_ORDERS_ATTEMPT, payload
})
const attemptSaveOrder = (payload) => ({
  type: Types.SAVE_ORDER_ATTEMPT, payload
})
const attemptUploadInvoice = (payload) => ({
  type: Types.UPLOAD_INVOICE_ATTEMPT,
  payload
})
const attemptCreatePackPdf = (payload) => ({
  type: Types.CREATE_PACK_PDF_ATTEMPT,
  payload
})
const attemptCreateCwOrder = (payload) => ({
  type: Types.CREATE_CW_ORDER_ATTEMPT,
  payload
})

export default {
  // User
  attemptFindOrders,
  attemptGetCart,
  attemptAddToCart,
  attemptSaveCart,
  attemptCheckout,
  attemptReorder,

  // Admin
  attemptFindAllOrders,
  attemptSaveOrder,
  attemptUploadInvoice,
  attemptCreatePackPdf,
  attemptCreateCwOrder
}



/** WEBPACK FOOTER **
 ** ./src/redux/order/orderActions.js
 **/